import { DRAWER_TYPES } from '@/constants/drawer';
import { ROLES } from '@/constants/roles';
import { isProductionMode, isVcht } from '@/constants/global';
import { PERMISSIONS } from '@/constants/permissions';
import { eventPlan, uiEventPlan } from '@/modules/EventsPlan/routes';

export const nominations = {
  path: '/nominations',
  name: 'nominations',
  component: () => import('./views/EventNominations.vue'),
  meta: {
    title: 'Номинации',
    icon: '$istar-outline',
    accessList: [ROLES.organization],
  },
};

export const eventsStock = {
  path: '/events/market',
  name: 'events-market',
  component: () => import('./views/MarketEvents/views/All.vue'),
  meta: {
    title: 'Биржа мероприятий',
    accessList: [ROLES.organization, ROLES.expert],
    icon: 'mdi-bank-outline',
    instruction: {
      id: 115,
      name: 'Создание заявки',
    },
    layout: 'ui-design',
    back: true,
    children: [
      {
        text: 'Поиск мероприятий',
        to: '/events/market',
        icon: 'mdi-store',
        visibleFor: [ROLES.organization],
      },
      {
        text: 'Мои заявки',
        to: '/events/market/my-requests',
        icon: 'mdi-folder-account',
        visibleFor: [ROLES.organization],
      },
      {
        text: 'Заявки организаторов',
        icon: 'mdi-account-tie',
        to: '/organization/events/manage',
        visibleFor: [ROLES.organization],
      },
    ],
  },
};

export const eventsRequestedStock = {
  path: '/events/market/my-requests',
  name: 'events-market-requests',
  component: () => import('./views/MarketEvents/views/Requested.vue'),
  meta: {
    title: 'Мои заявки',
    accessList: [ROLES.organization, ROLES.expert],
    layout: 'ui-design',
    back: true,
  },
};

export const eventsExpertManagement = {
  path: '/expert-events',
  name: 'expert-events',
  component: () => import('./views/management/expert.vue'),
  meta: {
    accessList: [ROLES.expert],
  },
};

export const eventAssociations = {
  path: '/organization-event-associations',
  name: 'organization-event-associations',
  component: () => import('./views/event-associations/event-associations.vue'),
  meta: {
    title: 'Ассоциации',
    icon: '$ifolder-favorite-outline',
    accessList: [ROLES.organization],
  },
};
export const eventAssociation = {
  path: '/organization-event-association/:id',
  name: 'organization-event-association',
  component: () => import('./views/event-associations/event-association.vue'),
  meta: {
    title: 'Ассоциация',
  },
};

export const eventsCertificateManagement = {
  path: '/certificate-events',
  name: 'certificate-events',
  component: () => import('./views/management/certificate.vue'),
  meta: {
    accessList: [ROLES.certificate, ROLES.member],
  },
};

export const eventsOrganizationManagementLink = {
  name: 'organization-events-my',
  meta: {
    title: 'Мои мероприятия',
    accessList: [ROLES.organization],
  },
};

export const eventsOrganizationManagement = {
  path: '/organization-events',
  name: 'organization-events',
  component: () => import('./views/management/organization/index.vue'),
  redirect: () => ({
    name: 'ui-events-organizer',
  }),
  children: [
    {
      name: 'organization-events-my',
      path: 'my',
      component: () => import('./views/management/organization/children/my.vue'),
      meta: {
        title: 'Мои мероприятия',
        layout: 'ui-design',
        accessList: [ROLES.organization],
      },
      redirect: () => ({
        name: 'ui-events-organizer',
      }),
    },
    {
      name: 'organization-events-assigned',
      path: 'assigned',
      component: () => import('./views/management/organization/children/assigned.vue'),
      meta: {
        title: 'Назначенные мероприятия',
        layout: 'ui-design',
        accessList: [ROLES.organization],
      },
      redirect: () => ({
        name: 'ui-events-organizer',
      }),
    },
  ],
  meta: {
    title: 'Мероприятия',
    layout: 'ui-design',
    accessList: [ROLES.organization],
  },
};

export const uiEventsStockDashboard = {
  path: '/events/market-dashboard',
  name: 'events-market-dashboard',
  component: () => import('./views/MarketEvents/views/Dashboard.vue'),
  meta: {
    title: 'Совместные мероприятия',
    accessList: [ROLES.organization, ROLES.expert],
    layout: 'ui-design',
  },
};

export const events = {
  meta: {
    title: 'Мероприятия',
    icon: '$icalendar',
    accessList: [ROLES.organization, ROLES.certificate, ROLES.member, ROLES.expert, ROLES.trainer, ROLES.event_manager],
    instruction: {
      id: { [ROLES.member]: 29, [ROLES.certificate]: 29 },
      name: 'Мероприятия',
    },
    children: [
      {
        text: 'Управление мероприятиями',
        to: '/organization-events/my',
        icon: 'mdi-calendar-edit',
        visibleFor: [ROLES.organization, ROLES.event_manager],
      },
      // {
      //   text: 'Группы мероприятий',
      //   to: '/event/categories',
      //   icon: 'mdi-calendar-multiple',
      //   visibleFor: [ROLES.organization],
      // },
      {
        text: 'Создать мероприятие',
        to: isProductionMode ? '/event/create' : '/event/template-create', // ШАБЛОНЫ (ТИПЫ) МЕРОПРИЯТИЙ: закрыты на проде
        icon: `mdi-calendar-plus`,
        vchtWhitelisted: isVcht,
        visibleFor: [ROLES.organization, ROLES.event_manager],
        accessFor: [PERMISSIONS.event_create],
      },
      // {
      //   text: 'Черновики',
      //   to: '/event/drafts',
      //   icon: 'mdi-calendar-text-outline',
      //   visibleFor: [ROLES.organization],
      // },
      {
        text: 'Мои мероприятия',
        to: '/certificate-events',
        icon: 'mdi-calendar-account-outline',
        visibleFor: [ROLES.member, ROLES.certificate],
      },
      // 11.12.2024 (9:44 MSK): Вадим сказал, функционал не выпиливаем,
      // это система заявочных этапов, пока просто скрываем
      // {
      //   text: 'Заявочные этапы',
      //   to: '/qualifications',
      //   icon: 'mdi-card-bulleted-settings-outline',
      //   visibleFor: [ROLES.member, ROLES.certificate],
      // },
      {
        text: 'Задания',
        to: '/polls/event',
        icon: 'mdi-format-list-checks',
        visibleFor: [ROLES.member, ROLES.certificate],
      },
      {
        text: 'Модерация мероприятий',
        icon: 'mdi-text-box-check-outline',
        to: '/events/moderation',
        visibleFor: [ROLES.operator, ROLES.moderator],
      },
      // {
      //   text: 'Коэффициенты мероприятий',
      //   to: '/events/significance-coefficient',
      //   icon: 'mdi-chart-pie',
      //   visibleFor: [ROLES.operator],
      // },
      {
        text: 'Готовность муниципалитетов',
        to: '/operator-appoint',
        icon: 'mdi-pencil-ruler',
        visibleFor: [ROLES.operator],
      },
      {
        text: 'Оценка работ',
        to: '/grading-assignments',
        icon: 'mdi-calendar-account-outline',
        visibleFor: [ROLES.expert],
      },
      // ТУТ ПОТОМ БУДЕТ СТАТИСТИКА ПО РАБОТАМ ДЛЯ ЭКСПЕРТА
      // {
      //   text: 'Результаты мероприятий',
      //   to: '/events/results',
      //   icon: 'mdi-trophy-award',
      //   visibleFor: [ROLES.expert],
      // },
    ],
  },
};

export default [
  events,
  eventsStock,
  eventPlan,
  uiEventPlan,
  eventAssociation,
  eventAssociations,
  uiEventsStockDashboard,
  eventsRequestedStock,
  eventsOrganizationManagement,
  eventsCertificateManagement,
  eventsExpertManagement,
  nominations,
  {
    path: '/events-search',
    name: 'event-search',
    component: () => import('@/modules/Events/views/events-search.vue'),
    meta: {
      title: 'Поиск мероприятий',
    },
  },
  // {
  //   path: '/event/create',
  //   name: 'event-create',
  //   component: () => import('./views/CreateEvent/index.vue'),
  //   meta: {
  //     title: 'Создание мероприятия',
  //     accessList: [ROLES.organization, ROLES.operator],
  //     instruction: { id: 1, name: 'Создание мероприятия' },
  //     subdrawer: DRAWER_TYPES.portal,
  //   },
  // },
  {
    path: '/event/create',
    name: 'event-create',
    component: () => import('@/modules/Events/views/event-create-redesign.vue'),
    meta: {
      title: 'Создание мероприятия',
      accessList: [ROLES.organization, ROLES.operator, ROLES.event_manager, ROLES.admin],
      permissionsList: [PERMISSIONS.event_create],
      instruction: { id: 1, name: 'Создание мероприятия' },
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: '/event/template-create',
    name: 'event-create-by-template',
    component: () => import('@/modules/Events/views/event-create-by-template.vue'),
    meta: {
      title: 'Создание мероприятия',
      accessList: [ROLES.organization, ROLES.operator, ROLES.event_manager],
      permissionsList: [PERMISSIONS.event_create],
    },
  },
  // {
  //   path: '/event/view/:id',
  //   name: 'event-view',
  //   component: () => import('./views/Event/index.vue'),
  //   meta: {
  //     title: 'Просмотр Мероприятий',
  //     subdrawer: DRAWER_TYPES.portal,
  //   },
  // },
  // { // NOTE: Можно удалять компонент, мы его не используем, но пока оставлю тут
  //   path: '/event/:id/edit',
  //   name: 'event-edit',
  //   component: () => import('./views/EditEvent/index.vue'),
  //   meta: {
  //     title: 'Редактирование мероприятия',
  //     accessList: [ROLES.organization, ROLES.operator],
  //     subdrawer: DRAWER_TYPES.portal,
  //   },
  //   props: true,
  // },
  // {
  //   path: '/events/significance-coefficient',
  //   name: 'events-significance-coefficient',
  //   component: () => import('./views/SignificanceCoefficient/index.vue'),
  //   meta: {
  //     accessList: [ROLES.operator],
  //     instruction: {
  //       id: 44,
  //       name: 'Коэффициенты мероприятий',
  //     },
  //   },
  // },
  {
    path: '/event/drafts',
    name: 'event-drafts',
    component: () => import('./views/Drafts/index.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/events/market-applications',
    name: ' events/market-applications',
    component: () => import('./views/MarketEventsApplications/index.vue'),
    meta: {
      accessList: [ROLES.organization],
      layout: 'ui-design',
    },
  },
  {
    path: '/events/market-applications/:id',
    name: ' events/market-applications-id',
    component: () => import('./views/MarketEventApplications/index.vue'),
    meta: {
      accessList: [ROLES.organization],
      layout: 'ui-design',
    },
  },
  {
    path: '/operator-appoint',
    name: 'operator-appoint',
    component: () => import('./views/OperatorAppointEvents/index.vue'),
    meta: {
      accessList: [ROLES.operator],
      instruction: {
        id: 15,
        name: 'Готовность муниципалитетов',
      },
    },
  },
  {
    path: '/operator-appoint/:id',
    name: 'operator-appoint-id',
    component: () => import('./views/OperatorAppoint/index.vue'),
    meta: {
      accessList: [ROLES.operator],
    },
  },
  {
    path: '/department-events',
    name: 'department-events',
    component: () => import('./views/DepartamentEvents/index.vue'),
    meta: {
      accessList: [ROLES.department],
    },
  },
  // {
  //   path: '/event/register/:id',
  //   name: 'event-register',
  //   component: () => import('./views/event-register.vue'),
  //   meta: {
  //     title: 'Запись на мероприятие',
  //   },
  // },
  {
    // Remove later !!!!!
    path: '/event/import-members/:id',
    name: 'import-members',
    component: () => import('./views/import-members.vue'),
    meta: {
      title: 'Импорт участников',
    },
  },
  {
    path: '/event/reports/:id',
    name: 'event-reports-item',
    component: () => import('./views/event-dashboard/reports.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event/dashboard/:id',
    name: 'event-dashboard',
    component: () => import('./views/event-dashboard/index.vue'),
    children: [
      {
        path: 'main',
        name: 'event-dashboard-main',
        component: () => import('@/modules/Events/components/event-view/EventSectionContainer.vue'),
        meta: {
          redesign: true,
          editor: true,
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'organizers',
        name: 'event-dashboard-organizers',
        component: () => import('./views/event-dashboard/organizers.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
          title: 'Организаторы',
        },
      },
      {
        path: 'level-documents',
        name: 'event-dashboard-level-documents',
        component: () => import('./views/event-dashboard/level-documents.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
          title: 'Документы',
        },
      },
      {
        path: 'level-document/:documentId?',
        name: 'event-dashboard-level-document',
        component: () => import('./views/event-dashboard/level-document.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
          title: 'Документ',
        },
      },
      {
        path: 'level-management',
        name: 'event-level-management',
        component: () => import('./views/event-dashboard/organizers/level-management.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
          title: 'Шаблоны мероприятий',
        },
      },
      {
        path: 'owner-exchange',
        name: 'owner-exchange-view-id',
        component: () => import('./views/event-dashboard/organizers/owner-exchange.vue'),
        meta: {
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
          instruction: { id: 29, name: 'Назначение организаторов' },
          title: 'Назначение организаторов',
        },
      },
      {
        path: 'owner-exchange-2',
        name: 'organization-events-manage-event-view-id',
        component: () => import('./views/event-dashboard/organizers/owner-exchange-2.vue'),
        meta: {
          title: 'Заявки организаторов',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
          layout: 'ui-design',
          back: true,
        },
      },
      {
        path: 'quota',
        name: 'event-quota',
        component: () => import('./views/event-dashboard/organizers/quota.vue'),
        meta: {
          title: 'Настройка квоты',
          subdrawer: DRAWER_TYPES.portal,
          accessList: [ROLES.organization],
          layout: 'ui-design',
          back: true,
        },
      },
      {
        path: 'applications',
        name: 'event-applications',
        component: () => import('./views/event-dashboard/members/applications.vue'),
        meta: {
          title: 'Заявки участников',
          accessList: [ROLES.organization],
          instruction: {
            id: 16,
            name: 'Заявки участников',
          },
          subdrawer: DRAWER_TYPES.portal,
          resetParentSubdrawer: true,
        },
      },
      {
        path: 'teams-management',
        name: 'event-teams-management',
        component: () => import('./views/event-dashboard/members/teams-management.vue'),
        meta: {
          title: 'Заявки участников',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
          resetParentSubdrawer: true,
        },
      },
      {
        path: 'stage-control',
        name: 'stage-control-id',
        component: () => import('./views/event-dashboard/members/stages-control.vue'),
        meta: {
          accessList: [ROLES.organization],
          title: 'Допуск к этапам',
          instruction: {
            id: 17,
            name: 'Перенос участников и команд',
          },
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'reward',
        name: 'reward',
        component: () => import('./views/event-dashboard/members/awarding.vue'),
        meta: {
          accessList: [ROLES.organization],
          title: 'Награждение',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'achievements',
        name: 'event-achievements',
        component: () => import('./views/event-dashboard/members/achievements.vue'),
        meta: {
          accessList: [ROLES.organization],
          title: 'Дополнительные награды',
        },
      },
      {
        path: 'team-manager',
        name: 'organization-team-manage-event-id',
        component: () => import('./views/event-dashboard/members/team-manager.vue'),
        meta: {
          title: 'Управление командами',
          accessList: [ROLES.organization],
          instructin: {
            id: 20,
            name: 'Управление командами',
          },
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      // 11.12.2024 (9:44 MSK): Вадим сказал, функционал не выпиливаем,
      // это система заявочных этапов, пока просто скрываем
      // {
      //   path: 'qualification',
      //   name: 'qualification',
      //   component: () => import('./views/event-dashboard/polls/qualification.vue'),
      //   meta: {
      //     title: 'Проверка работ',
      //     accessList: [ROLES.organization],
      //     subdrawer: DRAWER_TYPES.portal,
      //     instruction: {
      //       id: 5,
      //       name: 'Проверка работ',
      //     },
      //   },
      // },
      // TODO: Удалить 15 Февраля 2025г. (вместе с зависимостями внутри)
      // DEPRECATED
      // {
      //   path: 'subordinate-members',
      //   name: 'subordinate-members',
      //   component: () => import('./views/event-dashboard/members/subordinate-members.vue'),
      //   meta: {
      //     accessList: [ROLES.organization],
      //     title: 'Передача участников',
      //     subdrawer: DRAWER_TYPES.portal,
      //   },
      // },
      {
        path: 'subordinate-members',
        name: 'subordinate-members',
        component: () => import('./views/event-dashboard/members/new-subordinate-members.vue'),
        meta: {
          accessList: [ROLES.organization],
          title: 'Передача участников',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'polls-settings/:pollId',
        name: 'polls-settings',
        component: () => import('@/modules/Poll/views/task-management.vue'),
        meta: {
          title: 'Редактирование задания',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'polls-edit',
        name: 'polls-edit',
        component: () => import('./views/event-dashboard/polls/stage-poll-panel.vue'),
        meta: {
          title: 'Настройка заданий',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
          instruction: {
            id: 6,
            name: 'Настройка заданий',
          },
        },
      },
      {
        path: 'event-dreamteam',
        name: 'event-dreamteam',
        component: () => import('./views/event-dashboard/members/dreamteam.vue'),
        meta: {
          title: 'Формирование команды',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'experts',
        name: 'event-experts',
        component: () => import('./views/event-dashboard/expertise/experts.vue'),
        meta: {
          title: 'Прикрепление экспертов к номинациям',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'polls',
        name: 'event-dashboard-polls',
        component: () => import('./views/event-dashboard/polls.vue'),
        meta: {
          title: 'Задания',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'expertise',
        name: 'expertise',
        component: () => import('./views/event-dashboard/expertise.vue'),
        meta: {
          title: 'Экспертиза',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'polls-expertise',
        name: 'polls-expertise',
        component: () => import('./views/event-dashboard/polls-expertise.vue'),
        meta: {
          title: 'Экспертиза',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'members',
        name: 'event-dashboard-members',
        component: () => import('./views/event-dashboard/members.vue'),
        meta: {
          title: 'Участники',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'import-members',
        name: 'event-import-members',
        component: () => import('./views/import-members.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
          title: 'Импорт участников',
        },
      },
      {
        path: 'curators',
        name: 'event-curators',
        component: () => import('./views/event-dashboard/curators.vue'),
        meta: {
          title: 'Кураторы',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'managers',
        name: 'dashboard-event-managers',
        component: () => import('./views/event-dashboard/event-managers.vue'),
        meta: {
          title: 'Event-менеджеры',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'monitoring',
        name: 'dashboard-event-monitoring',
        component: () => import('./views/event-dashboard/monitoring.vue'),
        meta: {
          title: 'Мониторинг',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'activity-statistics',
        name: 'dashboard-event-activity-statistics',
        component: () => import('./views/event-dashboard/activity-statistics.vue'),
        meta: {
          title: 'Статистика активности',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'pfdo-exports',
        name: 'pfdo-exports',
        component: () => import('./views/event-dashboard/pfdo-exports.vue'),
        meta: {
          title: 'Статистика отправки',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'form-constructor',
        component: () => import('./views/event-dashboard/form-constructor.vue'),
        meta: {
          title: 'Приём заявок',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'reports',
        name: 'event-dashboard-reports',
        component: () => import('./views/event-dashboard/reports.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'program',
        name: 'event-dashboard-program',
        component: () => import('./views/event-dashboard/program.vue'),
      },
      {
        path: 'informing',
        name: 'informing',
        component: () => import('./views/event-dashboard/informing.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'exhibitions',
        name: 'exhibitions',
        component: () => import('./views/event-dashboard/event-exhibitions/event-exhibitions.vue'),
        meta: {
          title: 'Выставки',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'exhibition/:exhibitionId?',
        name: 'exhibition',
        component: () => import('./views/event-dashboard/event-exhibitions/event-exhibition.vue'),
        meta: {
          title: 'Выставка',
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'partners',
        name: 'partners',
        component: () => import('./views/event-dashboard/partners.vue'),
        meta: {
          title: 'Партнёры',
          subdrawer: DRAWER_TYPES.portal,
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'partner/:partnerId?',
        name: 'partner',
        component: () => import('./views/event-dashboard/partners/partner.vue'),
        meta: {
          title: 'Партнёр',
          subdrawer: DRAWER_TYPES.portal,
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'invitations',
        name: 'informing-invitations',
        component: () => import('@/modules/Events/views/event-dashboard/informing/invitations.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'chats',
        name: 'informing-chats',
        component: () => import('@/modules/Events/views/event-dashboard/informing/chats.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'news',
        name: 'informing-news',
        component: () => import('@/modules/Events/views/event-dashboard/informing/news.vue'),
        meta: {
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'edit-certificate',
        component: () => import('./components/certificate-settings/CertificateEdit.vue'),
        meta: {
          float: true,
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'team-patterns',
        component: () => import('@/modules/Events/views/event-dashboard/organizers/team-patterns.vue'),
        meta: {
          accessList: [ROLES.organization],
        },
      },
      {
        path: 'teams-constructor',
        component: () => import('@/modules/Events/views/event-dashboard/members/teams-constructor.vue'),
        meta: {
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'teams-control',
        component: () => import('@/modules/Events/views/event-dashboard/members/teams-control.vue'),
        meta: {
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
      {
        path: 'votes',
        name: 'event-dashboard-votes',
        component: () => import('@/modules/Events/views/event-dashboard/votes.vue'),
        meta: {
          title: 'Голосование',
          accessList: [ROLES.organization],
          subdrawer: DRAWER_TYPES.portal,
        },
      },
    ],
    meta: {
      title: 'Панель управления',
      accessList: [ROLES.organization, ROLES.operator, ROLES.event_manager, ROLES.admin],
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: '/event/:id/program',
    name: 'event-program-list',
    component: () => import('./views/event-stages-activities-list.vue'),
    meta: {
      title: 'Активности мероприятия',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event/:id/program/create',
    name: 'event-program-create',
    component: () => import('./views/event-stages-activities.vue'),
    meta: {
      title: 'Создание активности',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event/:id/program/edit/:idStage/:idActivity',
    name: 'event-program-edit',
    component: () => import('./views/event-stages-activities.vue'),
    meta: {
      title: 'Редактирование активности',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/events/results',
    name: 'event-reports-results',
    component: () => import('./views/management/expert.vue'),
    meta: {
      isClosedEvent: true,
      accessList: [ROLES.expert],
    },
  },
  {
    path: '/events',
    name: 'event-reports',
    component: () => import('./views/management/expert.vue'),
    meta: {
      accessList: [ROLES.expert, ROLES.organization],
    },
  },
  {
    path: '/event/:eventId/news/:id',
    name: 'news-view',
    component: () => import('./views/news-view.vue'),
    meta: {
      title: 'Просмотр новости',
    },
  },
];
